let productGroupsCache = [];

function swatches(){
  Array.from(document.getElementsByClassName('color-swatches__container')).forEach(
    el => {
      //console.log(el.dataset.groupTag)
      if(el.dataset.groupTag){
        addSwatches(el)
      } else {
        addSingleSwatch(el)
      }
    }
  )

  function findColor(title){
    if(title.includes('- ')){
      return title.split('- ')[title.split('- ').length - 1].toLowerCase();
    }
  }

  function findStyle(title){
    if(title.includes('- ')){
      let color = title.split('- ')[title.split('- ').length - 1];
      let colorObj = colorSwatchConfig.find( obj => obj.name == color.trim().toLowerCase());
      if(colorObj){
        return colorObj.style;
      }
    }
    return 'background:gray'
  }

  function buildSwatch(edge, containerElement = null){
    let whiteSwatch = ``
    if(findColor(edge.node.title) == "white") {
      whiteSwatch = ` color-swatch--white`
    }

    let path = location.pathname.split('/products/')[1]

    let isCurrent = false;
    // Check if on the PDP swatche container
    if (!containerElement || !containerElement.closest('.product-card')) {
      isCurrent = path === edge.node.handle;
    }
    
    // For PLP and other contexts (including recommendations on PDP), check if this product card is the current one being rendered
    if (!isCurrent && containerElement) {
      const productCard = containerElement.closest('.product-card');
      if (productCard) {
        const cardProductHandle = productCard.id;
        const cardProductTitle = productCard.querySelector('[data-title]')?.dataset.title || '';
        const swatchHandle = containerElement.dataset.handle;
        
        if (cardProductHandle === edge.node.id || 
            swatchHandle === edge.node.handle ||
            (cardProductTitle && edge.node.title && cardProductTitle.toLowerCase() === edge.node.title.toLowerCase())) {
          isCurrent = true;
        }
      }
    }

    let seasonalColorClass = '';
    if(window.location.pathname.includes('/products/')){
      if(edge.node.tags.includes('1_test_seasonal_color') || edge.node.tags.includes('seasonal_color')){
        seasonalColorClass = ' seasonal-color';
        if(document.getElementsByClassName('color-swatches__label--seasonal').length > 0){
          document.getElementsByClassName('color-swatches__label--seasonal')[0].style.display = 'block';
        }
      }
    }

    if (isCurrent) {      
      return `<div class="color-swatch ${whiteSwatch} current ${seasonalColorClass}" style="${findStyle(edge.node.title)}"></div>`;
    }

    //if(edge.node.availableForSale){
      return `<a class="color-swatch ${whiteSwatch} ${seasonalColorClass}" href="/products/${edge.node.handle}" aria-label="${edge.node.title.split('- ').pop().trim()}" style="${findStyle(edge.node.title)}"></a>`;
    //}
  }

  async function addSwatches(el){
    //console.log('productGroupsCache***********')
    //console.log(productGroupsCache)
    let cachedGroup = productGroupsCache.find(group => group.tag == el.dataset.groupTag)
    
    // Check if swatches are inside .product-wrapper (main PDP product) - show all
    // Otherwise limit to 5 (recommended products, collection pages, etc.)
    const isInProductWrapper = el.closest('.product-wrapper') !== null;
    
    if(cachedGroup){
      //console.log('************cached group***********')
      //console.log(cachedGroup)
      let html = ``;
      let products = cachedGroup.products;
      
      if(isInProductWrapper) {
        products.forEach(edge => {
          html += buildSwatch(edge, el);
        });
      } else {
        let visibleProducts = products.slice(0, 5);
        let remainingCount = products.length - 5;
        
        visibleProducts.forEach(edge => {
          html += buildSwatch(edge, el);
        });
        
        if(remainingCount > 0) {
          let firstProductHandle = products[0].node.handle;
          html += `<a class="color-swatch color-swatch--remaining" href="/products/${firstProductHandle}">+${remainingCount}</a>`;
        }
      }
      
      el.innerHTML = html;
    } else {
      const products = await getProductsByTag(el.dataset.groupTag);
      //console.log('************products***********')
      //console.log(products)

      let html = ``;
      let productEdges = products.data.products.edges;
      
       if(isInProductWrapper) {
        productEdges.forEach(edge => {
          html += buildSwatch(edge, el);
        });
      } else {
        let visibleProducts = productEdges.slice(0, 5);
        let remainingCount = productEdges.length - 5;
        
        visibleProducts.forEach(edge => {
          html += buildSwatch(edge, el);
        });
        
        if(remainingCount > 0) {
          let firstProductHandle = productEdges[0].node.handle;
          html += `<a class="color-swatch color-swatch--remaining" href="/products/${firstProductHandle}">+${remainingCount}</a>`;
        }
      }
      
      el.innerHTML = html;

    }
  }


  function getProductsByTag(tag){
    //console.log('tag')
    //console.log(tag)
    let tagEsc = tag.replace(":", "\\:");
    return new Promise((resolve) => {

      const query =  `query productsByTag ($limit:Int, $tagQuery:String) {
        products(first: $limit, query:$tagQuery ) {
          edges {
            node {
              availableForSale
              title
              handle
              id
              tags
            }
          }
        }
      }`

      fetch('https://belladahl.com/api/graphql', {
        method: "POST",
        headers: {
          "X-Shopify-Storefront-Access-Token":"82d40a3a82deccc47cee6e213dea291c",
        "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({ 
          query: query,
          variables: {
            limit: 20,
            tagQuery: `tag:${tagEsc}`,
          }
        })
      }).then(res => {
        return res.json();  
      }).then(data => {
        //console.log('data.data.products.edges');
        //console.log(data.data.products.edges);
        productGroupsCache.push({
          tag: tag,
          products: data.data.products.edges
        })
        resolve(data)
      }).catch(err => {
        console.log(err)
      })
    });
  }    

  function addSingleSwatch(el){
    if(el.dataset.hasOwnProperty('title')){
      let whiteSwatch = ``
      if(findColor(el.dataset.title) == "white") {
        whiteSwatch = ` color-swatch--white`
      }
      el.innerHTML = `<div class="color-swatch ${whiteSwatch} current" style="${findStyle(el.dataset.title)}"></div>`;
    }
  }
}


if(window.location.pathname.includes('/collections/') && !window.location.pathname.includes('/products/')){
  swatches();
} else {
  let interval,
  counter = 0,
  duration = 250,
  limit = 40;
  interval = setInterval( () => {
    if (document.getElementsByClassName('color-swatches__container').length > 0){

      swatches();
      clearInterval( interval );
    } else if ( counter === limit ) {
      clearInterval ( interval );
    } 
  }, duration );

  //setTimeout(()=>{
    //swatches();
  //}, 1500)
}